import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "94121601-9e6e-4744-a720-3484dc7b15b9",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "838ddf3f-7736-4b3f-9e68-0b02247ccf55",
      type: "NineSlicePlane",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 358,
        y: 299
      },
      width: 716,
      height: 598,
      leftWidth: 156,
      topHeight: 139,
      rightWidth: 104,
      bottomHeight: 139,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_background_2",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "73d2c739-6c22-4f05-99df-199795a36945",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -248,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_title_purchase",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "abc0cec8-c740-4359-a2ec-9b7938096a5f",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 341,
      y: -250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "btn_close",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "8d13120d-5dce-4dea-8e91-027c11bb2277",
      type: "Text",
      name: "headerText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -256,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Remove Cards",
      localize: false,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#933019",
        strokeThickness: 6,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: true,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "02d5b708-2242-40ea-b0ba-e75a1c2e4c6c",
      type: "Text",
      name: "titleText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -167,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Remove Three Cards at level start",
      localize: false,
      maxWidth: 655,
      maxHeight: 76,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "c817daba-81fa-4394-9714-641bd08b1ef3",
      type: "Sprite",
      name: "character",
      nameSpace: "",
      className: "",
      x: -513,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "character_idle_1",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      type: "Container",
      name: "boosterContainerA",
      nameSpace: "",
      className: "",
      x: -162,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "68a1508c-6b41-426a-b94f-78c213b458e7",
      type: "Container",
      name: "boosterContainerB",
      nameSpace: "",
      className: "",
      x: 162,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "fb207473-be7e-4be5-a559-a827a2ef51af",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x1_bg",
      parent: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      data: ""
    },
    {
      id: "0c34f426-383b-4595-80f7-30ba66671446",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x1_frame",
      parent: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      data: ""
    },
    {
      id: "c0cda859-7e7b-4b92-91c3-2ee7e0969991",
      type: "Sprite",
      name: "iconA",
      nameSpace: "",
      className: "",
      x: 2,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_joker",
      parent: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      data: ""
    },
    {
      id: "777b0115-3582-4b35-95be-f83e81cb72db",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 73,
      y: 114,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x1",
      parent: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      data: ""
    },
    {
      id: "0f4bbe22-7be0-48ff-ba12-a71e0f11f3bf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 245,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "d9f20d9c-f305-4b0b-802c-859bb65b5c62",
      data: ""
    },
    {
      id: "92573935-3680-4081-8c2b-e9b4492cca22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x3_bg",
      parent: "68a1508c-6b41-426a-b94f-78c213b458e7",
      data: ""
    },
    {
      id: "d1aa4e32-5b93-487a-88b6-6ba0611f461d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x3_frame",
      parent: "68a1508c-6b41-426a-b94f-78c213b458e7",
      data: ""
    },
    {
      id: "a6bef1b9-e9ed-4a55-b5cb-3a5bf0d5e417",
      type: "Sprite",
      name: "iconB",
      nameSpace: "",
      className: "",
      x: 2,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_joker",
      parent: "68a1508c-6b41-426a-b94f-78c213b458e7",
      data: ""
    },
    {
      id: "d2f53ae7-6142-47d9-b667-7f00031dd17f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 73,
      y: 114,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "purchase_x3",
      parent: "68a1508c-6b41-426a-b94f-78c213b458e7",
      data: ""
    },
    {
      id: "0d70ed34-beae-4201-9f1c-05e56dbb36f7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 245,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "68a1508c-6b41-426a-b94f-78c213b458e7",
      data: ""
    },
    {
      id: "007aa10d-4c01-4490-ad1c-90cef7d8adac",
      type: "Sprite",
      name: "buyButtonA",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "0f4bbe22-7be0-48ff-ba12-a71e0f11f3bf",
      data: ""
    },
    {
      id: "84307934-9dd1-4794-867f-c109680b56b8",
      type: "Sprite",
      name: "buyButtonB",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "0d70ed34-beae-4201-9f1c-05e56dbb36f7",
      data: ""
    },
    {
      id: "d17e36f6-8684-4dd7-ad5f-cc00767c5a6b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -145,
      y: -70,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "btn_label_small",
      parent: "0d70ed34-beae-4201-9f1c-05e56dbb36f7",
      data: ""
    },
    {
      id: "2de2faaa-1ebd-4255-962a-61f0bdb23d1e",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -109,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -62,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "-10%",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#C6110A",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "0d70ed34-beae-4201-9f1c-05e56dbb36f7",
      data: ""
    },
    {
      id: "7e3e8eef-ed49-471b-85a5-f96163c61dcd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -67,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium_popup",
      parent: "007aa10d-4c01-4490-ad1c-90cef7d8adac",
      data: ""
    },
    {
      id: "7d8c5e1d-d26f-469d-b871-73d751fcad40",
      type: "Text",
      name: "priceA",
      nameSpace: "",
      className: "",
      x: -18,
      y: -3,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "2400",
      localize: false,
      maxWidth: 131,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#074829",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "007aa10d-4c01-4490-ad1c-90cef7d8adac",
      data: ""
    },
    {
      id: "4733d711-c488-4b50-abbb-c60851b83a80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -59,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium_popup",
      parent: "84307934-9dd1-4794-867f-c109680b56b8",
      data: ""
    },
    {
      id: "94a72c89-591f-4b2d-bb0f-f84d9dca6900",
      type: "Text",
      name: "priceB",
      nameSpace: "",
      className: "",
      x: -18,
      y: -3,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "8200",
      localize: false,
      maxWidth: 131,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#074829",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "84307934-9dd1-4794-867f-c109680b56b8",
      data: ""
    }
  ]
} as const;

export class BuyBoosterPopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  closeButton: GameObject<PIXI.Sprite>;
  headerText: GameObject<PIXI.Text>;
  titleText: GameObject<PIXI.Text>;
  character: GameObject<PIXI.Sprite>;
  boosterContainerA: GameObject<PIXI.Container>;
  iconA: GameObject<PIXI.Sprite>;
  buyButtonA: GameObject<PIXI.Sprite>;
  priceA: GameObject<PIXI.Text>;
  boosterContainerB: GameObject<PIXI.Container>;
  iconB: GameObject<PIXI.Sprite>;
  buyButtonB: GameObject<PIXI.Sprite>;
  priceB: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
